import { combineReducers } from "redux";
import authReducer from "./auth.reducer";
import userReducer from "./user.reducer";
import masterReducer from "./master.reducer";
import pricingChartReducer from "./pricingChart.reducer";
import LotCodeReducer from "./lotCode.reducer";
import  ipAddressReducer  from "./ipAddress.reducer";
import imageReducer from "./image.reducer";

const appReducer = combineReducers({
    auth: authReducer,
    user: userReducer,
    master: masterReducer,
    priceChart: pricingChartReducer,
    lotCode:LotCodeReducer,
    ipAddress:ipAddressReducer,
    imageServer:imageReducer
});



const rootReducer = (state, action) => {
  if (action.type === 'RESET_ALL_STATE') {
    return appReducer(undefined, action); // Reset all reducers to initial state
  }
  return appReducer(state, action);
};

export default rootReducer;